<template>
  <div>
    <populate-form
      collapseStyle="simple"
      formTitle="課程核銷狀態報表"
      fkey="tm01"
      ref="filterForm"
      populateOptionVar="filterOptions"
      formDataObjVar="filterData"
    ></populate-form>
    <div class="wrapper2" ref="wrapper">
      <b-table  sticky-header="65vh" ref="scrollarea" class="" striped hover :items="items" :fields="fields">
      </b-table>
    </div>
  </div>
</template>

<script>

import { 
  apiGetTicketStatus,
  apiGetTicketStatusDownloadUrl,
  apiDownloadReportFile
 } from '@/api/SalesManage.js'

 import {
  apiDownloadFile
} from '@/api/Util.js'

import { read, write, utils } from 'xlsx';

export default {
  name: 'SalesViewTicketStatus',
  components: {
  
  },
  data: function () {
    return {
      filterData: {},
      filterOptions: [
        {
          componentType:'text',
          defaultValue:'',
          akey:'ticket_project_no',
          col:10,
          placeholder:'NI',
        },
        {
          componentType:'date-picker',
          defaultValue:null,
          akey:'view_start_date',
          col:3,
          placeholder:'尋找票券日期起',
        },
        {
          componentType:'date-picker',
          defaultValue:null,
          akey:'view_end_date',
          col:3,
          placeholder:'尋找票券日期迄',
        },
        {
          'componentType':'b-button',
          'placeholder':'查詢',
          'akey':'search',
          'col':2,
          'execCallback':this.searchResult
        },
        {
          'componentType':'b-button',
          'placeholder':'下載結果',
          'akey':'download_result',
          'col':2,
          'execCallback':this.downloadResult
        },
      ],
      fields: [
        {
          key: 'NI',
          label: 'NI',
          sortable: false,
        },
        {
          key: '年份',
          label: '年份',
          sortable: false,
        },
        {
          key: '月份',
          label: '月份',
          sortable: false
        },
        {
          key: '列印出的票券含作廢張數',
          label: '列印出的票券含作廢張數',
          sortable: false
        },
        {
          key: '已核銷張數',
          label: '已核銷張數',
          sortable: false
        },
        {
          key: '未核銷張數',
          label: '未核銷張數',
          sortable: false
        },
        {
          key:'已作廢張數',
          label:'已作廢張數',
        },
      ],
      items: [],
    }
  },
  methods: {
    searchResult: async function() {
      console.log('???!!!')
      console.log(this.filterData)

      if (this.filterData.ticket_project_no === undefined){
        alert('請填寫NI')
        return
      }

      if (this.filterData.view_start_date === undefined || this.filterData.view_start_date === null){
        alert('請填寫: 尋找票券日期起')
        return
      }

      if (this.filterData.view_end_date === undefined || this.filterData.view_end_date === null){
        alert('請填寫: 尋找票券日期迄')
        return
      }

      let ids = this.filterData.ticket_project_no.split(',')
      let result_mapper = {}

      for (let idx = 0; idx < ids.length; idx++){
        let param = {
          ticket_project_no: ids[idx],
          view_start_date: this.filterData.view_start_date,
          view_end_date: this.filterData.view_end_date,
        }
        console.log(param)
        await apiGetTicketStatus(param).then(function(resp){
          // if (resp.data.data === null){
          //   alert(resp.data.msg)
          //   return
          // }
          result_mapper[ids[idx]] = resp.data.data.data
        }).catch(function(error){
          console.log('error',error)
          result_mapper[ids[idx]] = []
          // that.$bus.fnShowInfo(data.msg)
        })
      }

      let display_rows = []
      console.log('result_mapper',result_mapper)
      let nis = Object.keys(result_mapper)
      for (let idx = 0; idx < nis.length; idx++) {
        display_rows.push({
          "NI": nis[idx]
        })
        display_rows = display_rows.concat(result_mapper[nis[idx]])
      }

      let total_row = this.caculateTotal(display_rows)
      display_rows.push(total_row)

        // 
        // 
        // 


      console.log('display_rows',JSON.stringify(display_rows))
      this.items = display_rows


        //  
        //   that.items = resp.data.data.data
        //   that.items.push(total_row)
        //   console.log(that.items)

    },
    caculateTotal: function(items) {
      let total_row = {}
      items.forEach(function(item){
        let keys = Object.keys(item)
        keys.forEach(function(key){
          if (total_row[key] === undefined && key !== '年份' && key !== '月份'){
            total_row[key] = 0;
          }
          if (total_row[key] !== undefined){
            total_row[key] += item[key]
          }
        })
      })
      total_row['NI'] = '總計'
      return total_row
    },
    sortRows: function(items) {
      let filter_data = {}
      items.forEach(function(item){
        if (filter_data[item.year] === undefined){
          filter_data[item.year] = {}
        }

        if (filter_data[item.year][item.month] === undefined){
          filter_data[item.year][item.month] = {}
        }
        filter_data[item.year][item.month] = item
      })

      let sort_years = Object.keys(filter_data).sort()
      let datas = []
      sort_years.forEach(function(year){
        let sort_months = Object.keys(filter_data[year])
        sort_months = sort_months.sort()
        sort_months.forEach(function(month){
          datas.push(filter_data[year][month])
        })
      })
      return datas
    },
    downloadResult: async function() {
      if (this.items.length <= 0) {
        alert('請先輸入查詢條件進行查詢')
        return
      }


      const worksheet = utils.json_to_sheet(this.items);


      const workbook = utils.book_new();

      utils.book_append_sheet(workbook, worksheet, 'Sheet1');


      const excelBuffer = write(workbook, { type: 'array', bookType: 'xlsx' });

      this.saveExcelFile(excelBuffer, `${this.filterData.ticket_project_no}.xlsx`);

    },
    saveExcelFile(buffer, filename) {
      const data = new Blob([buffer], { type: 'application/octet-stream' });
      const url = URL.createObjectURL(data);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
    },
  },
  created() {
  },
  mounted() {
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.preview_container{
  position: relative;
}
.preview_general{
  font-size: 12px;
  font-family: cwTeXKai, "Noto Serif TC", "Noto Sans SC", serif;
  font-weight: 300;
  position: absolute;
  top: 0px;
  left: 0px; 
  text-align: left;
  line-height: 1;
}
.total_no{
  top: 50px;
  left: 340px;
}
.order_no{
  top: 50px;
  left: 585px;
}
.barcode1{
  font-weight: 600;
  top: 12px;
  left: 700px;
}
.barcode2{
  font-weight: 600;
  top: 270px;
  left: 175px;
}
.qrcode1{
  font-weight: 600;
  top: 350px;
  left: 800px;
}
.p_name{
  top: 70px;
  left: 340px;
}
.p_remark1{
  top: 90px;
  left: 340px;
}
.p_price{
  top: 113px;
  left: 350px;
}
.p_end_date{
  top: 113px;
  left: 530px;  
}
.preview_content{
  /* z-index: 9999;  */
  top: 150px;
  left: 285px;
  width: 635px;
  height: 117.16px;
}
.s_firm{
  top: 280px;
  left: 370px;
}
.s_name{
  top: 297px;
  left: 530px;
}
.s_address{
  top: 315px;
  left: 370px;
}
.ss_firm{
  top: 345px;
  left: 340px;
}
.ss_invoice{
  top: 365px;
  left: 340px;
}
.ss_name{
  top: 383px;
  left: 340px;
}
.ss_address{
  top: 400px;
  left: 340px;
}
.ss_bank{
  top: 345px;
  left: 690px;
}
.ss_date{
  top: 363px;
  left: 690px;
}
.ss_period{
  top: 381px;
  left: 690px;
}
.ss_num{
  top: 400px;
  left: 690px;
}
.wrapper2 {
  height: 65vh;
  border-style: inset;
  max-height: 65vh;
}
.wrapper3 {
  height: 150px;
  overflow-y: scroll;
  border-style: inset;
}

</style>
